import { SVGProps } from 'react';

const InfoIcon = ({
  height = '44px',
  width = '44px',
  strokeWidth = '2',
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 44 44'
    className='stroke-current'
    {...props}
  >
    <g
      id='Icons_Actions_ic-actions-danger-simple'
      transform='translate(44 44) rotate(180)'
    >
      <g id='ic-actions-danger-simple' transform='translate(19.795 6.489)'>
        <rect
          id='Rectangle_5'
          data-name='Rectangle 5'
          width='3.63'
          height='21.782'
          rx='1'
          transform='translate(0.599)'
          fill='none'
          stroke='#32abc3'
          strokeLinecap='round'
          strokeLinejoin='bevel'
          strokeWidth={strokeWidth}
        />
        <rect
          id='Rectangle_6'
          data-name='Rectangle 6'
          width='4.847'
          height='4.847'
          rx='1.33'
          transform='translate(0 26.61)'
          fill='none'
          stroke='#32abc3'
          strokeLinecap='round'
          strokeLinejoin='bevel'
          strokeWidth={strokeWidth}
        />
      </g>
    </g>
  </svg>
);

export default InfoIcon;
